import React from 'react';

type Props = {
  completed: number;
  total: number;
  label?: string;
  striped?: boolean;
  className?: string;
};

const ProgressBar: React.FC<Props> = ({ completed, total, label, striped = true, className = '' }) => {
  const pct = total > 0 ? Math.max(0, Math.min(100, Math.round((completed / total) * 100))) : 0;
  // Tailwind cannot reliably generate every runtime percentage class.
  // Apply an inline width style for the visible bar so the fill animates correctly.
  const widthStyle: React.CSSProperties = { width: `${pct}%` };
  return (
    <div className={`progress-wrap ${className}`}>
      {label && (
        <div className="progress-label mb-2">
          <div className="text-sm text-gray-600">{label} ({completed}/{total})</div>
          <div className="progress-percent">{pct}%</div>
        </div>
      )}

      {/* Native progress for accessibility (visually hidden) */}
      <progress className="sr-only" value={completed} max={total || 100} aria-label={label ?? 'Progress'} />

      <div className="progress" aria-hidden="true">
        <div className={`bar ${striped ? 'striped' : ''}`} style={widthStyle} />
      </div>
    </div>
  );
};

export default ProgressBar;
